import reducers from '../reducers';
import { genericStoreSetup } from 'reactifi-local';

export default props => {
  const initialState = {};
  const store = genericStoreSetup(reducers, initialState);

  return store;
};
